<template>
  <v-card>
    <v-toolbar dense color="red lighten-1">
      <v-toolbar-title class="white--text">Imposto de Renda</v-toolbar-title>
    </v-toolbar>
    <v-data-table v-if="income_taxes" :headers="headers" :items="income_taxes">
      <template v-slot:item.actions="{ item }">
        <v-btn text small icon class="mr-2" color="green" @click="downloadPDF(item.id)">
          <v-icon medium> mdi-cloud-download </v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  name: 'IncomeTaxList',
  data: () => {
    return {
      headers: [
        { text: 'Ano', value: 'year' },
        { text: '', value: 'actions', width: '80' },
      ],
    }
  },
  computed: {
    ...mapState('employees', ['income_taxes']),
  },
  methods: {
    ...mapActions('employees', ['ActionDownloadIncomeTaxPDF']),
    async downloadPDF(id) {
      try {
        await this.ActionDownloadIncomeTaxPDF(id)
      } catch (error) {
        console.log(error)
      }
    },
  },
  mounted: () => {},
}
</script>
